import clsx from 'clsx';
import styles from './ToggleButtonPillGroup.module.css';

type ToggleButtonPillGroupProps = {
  className?: string;
  children: React.ReactNode;
  groupingVariant?: ToggleButtonPillGroupGroupingVariant;
};

// TODO: Implement the "Overflow" grouping variant.

export enum ToggleButtonPillGroupGroupingVariant {
  Clustering = 'clustering',
}

export function ToggleButtonPillGroup(props: ToggleButtonPillGroupProps) {
  const {
    className,
    children,
    groupingVariant = ToggleButtonPillGroupGroupingVariant.Clustering,
  } = props;

  return (
    <div
      className={clsx(styles['toggle-button-pill-group'], className)}
      data-grouping-variant={groupingVariant}
      role="group"
    >
      {children}
    </div>
  );
}
